import React from 'react';

/**
 * InlineLoader - Lightweight loader for inline sections
 * Shows a spinner with optional text, designed for use within content areas
 * 
 * @param {string} text - Loading text to display
 * @param {string} height - Height of the loader container (default: 200px)
 */
const InlineLoader = ({ text = 'Loading...', height = '200px' }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: height,
        padding: '20px',
      }}
    >
      <div
        style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      />
      <div
        style={{
          marginTop: '12px',
          color: '#666',
          fontSize: '14px',
        }}
      >
        {text}
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default InlineLoader;

